import { useState as l, useCallback as i, useEffect as p } from "react";
function g(n, u = !0) {
  const [c, r] = l(!1), [f, s] = l(null), [o, a] = l(null), e = i(() => (r(!0), s(null), a(null), n().then((t) => s(t)).catch((t) => a(t)).finally(() => r(!1))), [n]);
  return p(() => {
    u && e();
  }, [e, u]), { execute: e, pending: c, value: f, error: o };
}
export {
  g as default
};
